import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ContactStatus, ConsentTracking } from '@dev/ee-api/ee-api-models';
import { PrimaryButton, TertiaryButton } from '@dev/ee-components';

import { SetToastPortalWrapper } from '@/store/toast/actions';
import { AddMultipleContacts, PostContactsWithPatternStart, getIsContactsUploading } from '@/store/contacts/actions';
import { PostContactsParams, PostWithPatternParams } from '@/store/contacts/types';
import { getUploadStore, SetAnalyticsOpen } from '@/store/upload/actions';

import { ButtonFooterComponentProps } from '../../../ContactsUpload';
import { STEPS, ButtonFooter, ALL_CONTACTS_LIST } from '../../..';

export const ButtonFooterComponent = (props: ButtonFooterComponentProps): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch<any>();
    const upload = useSelector(getUploadStore);
    const isContactsUploading = useSelector(getIsContactsUploading);
    const uploadListname = upload?.fileuploaded?.FileName || 'New list';
    const {
        sourceType,
        encoding,
        pattern,
        contactsPasted,
        setCurrentStep,
        createList,
        listName,
        setListName,
        setValidListName,
        status,
        consentTracking,
        overrideCustomFields,
    } = props;

    const contactLists = [
        {
            value: '0',
            label: t('allcontacts'),
        },
    ];

    const preparePostWithPatternParams = (sourceType: string): PostWithPatternParams => ({
        createList: createList || false,
        encodingName: encoding || 'utf-8',
        status: ContactStatus[status],
        consentTracking: ConsentTracking[consentTracking] || ConsentTracking.Unknown,
        listName: listName || ALL_CONTACTS_LIST,
        FileName: upload?.fileuploaded?.FileName,
        Pattern: pattern,
        OverwriteCustomFields: overrideCustomFields,
        sourceType,
    });

    const preparePostParams = (): PostContactsParams => ({
        createList: createList || false,
        encodingName: encoding || 'utf-8',
        status,
        consentTracking: consentTracking || ConsentTracking.Unknown,
        listName: listName || ALL_CONTACTS_LIST,
        body: contactsPasted,
        OverwriteCustomFields: false,
    });

    const contiueBtnOnClick = (): void => {
        const existingListName = contactLists.find((list) => list.label === listName);

        if (existingListName && createList) {
            setValidListName(false);
            return;
        }
        if (createList) {
            setListName(uploadListname);
        }
        if (sourceType === 'upload' || sourceType === 'mailchimp') {
            dispatch(PostContactsWithPatternStart(preparePostWithPatternParams(sourceType)))
                .then(() => {
                    dispatch(SetToastPortalWrapper(true));
                    dispatch(SetAnalyticsOpen(true));
                })
                .catch(() => {
                    dispatch(SetAnalyticsOpen(false));
                });
            return;
        } else {
            dispatch(AddMultipleContacts(preparePostParams()));
        }
        dispatch(SetToastPortalWrapper(true));
        dispatch(SetAnalyticsOpen(true));
    };

    return (
        <ButtonFooter>
            <TertiaryButton
                id="back-button"
                text={t('back')}
                onClick={(): void => {
                    setCurrentStep(STEPS.ADDING_AND_FIELDS_REVIEW);
                }}
            />
            <PrimaryButton
                id="continue-button"
                text={t('continue')}
                onClick={contiueBtnOnClick}
                disabled={isContactsUploading}
            />
        </ButtonFooter>
    );
};
